;(function (angular) {
  'use strict'

  angular.module('kilo.routes.product-pack', [
    'kilo.routes.product-pack.list',
    'kilo.routes.product-pack.show'
  ])
  .config(RouteConfigurator)

  function RouteConfigurator ($stateProvider) {
    var parentState = {
      name: 'product-pack',
      url: '/product-pack',
      abstract: true
    }
    $stateProvider.state(parentState)
  }
})(window.angular)
